require('./brokerMarketsLastNewsView.scss');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const moment = require('moment');

// @components
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKBoxSectionContent } = require('commonsComponents/OKBoxSectionContent');
const { OKBoxNewPreview } = require('commonsComponents/OKBoxNewPreview');
const TabbedBox = require('components/commons/tabbedBox/tabbedBox');
const { Link } = require('react-router-dom');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const OKLoadingErrorMessage = require('components/commons/OKLoadingErrorMessage/OKLoadingErrorMessage');

// @actions
const brokerMarketsActions = require('actions/brokerMarkets');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const DATE_FORMAT_TYPES = require('commonsConstants/dateFormatTypes');

const BREADCRUMB = [
    {
        text: <FormattedText value="brokerMarketNews-savingsTitlte" />,
        url: '/myprofile/broker'
    },
    {
        text: <FormattedText value="broker-marketsTitle" />,
        url: '/myprofile/broker/markets'
    },
    {
        text: <FormattedText value="brokerMarketNews-lastNewsTitle" />,
        url: ''
    }
];

class BrokerMarketsLastNewsView extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            activeTab: 0,
            activeTabNewsDisplayed: []
        }
    }

    componentDidMount() {
        const { immBrokerMarket, requestLastNews } = this.props;

        if(immBrokerMarket.get('lastNews').length === 0)
            requestLastNews();
            this.setQuantityNews();
    }

    componentDidUpdate(prevProps) {
        const { immBrokerMarket } = this.props;

         if (immBrokerMarket.get("allTabsNews") !== prevProps.immBrokerMarket.get("allTabsNews") ) {
            this.setQuantityNews();
        }
    }

    setQuantityNews = () => {
        const { immBrokerMarket } = this.props;
        const  newsPerPage = immBrokerMarket.get("newsPerPage");
        const allTabsNews = immBrokerMarket.get("allTabsNews");

        if (allTabsNews.length > 0) {
            const newsPerTab = Array.from({length: allTabsNews.length}, () => newsPerPage)
            this.setState({activeTabNewsDisplayed: newsPerTab})
        }
    }

    buildLastNewsContent = () => {
        const { activeTab, activeTabNewsDisplayed } = this.state;
        const { immBrokerMarket, originCountry } = this.props;
        const loading = immBrokerMarket.get("fetchingLastNews");

        let lastNews;
        if (activeTab !== 0 && !loading) {
            const tabsData = immBrokerMarket.get("allTabsNews");
            const tabSelectedValue = tabsData[activeTab];
            lastNews = immBrokerMarket.get(tabSelectedValue).toJS();
        } else {
            lastNews = immBrokerMarket.get("lastNews")
        }

        const getActiveTabNewsDisplayed = activeTabNewsDisplayed[activeTab];

        const buildedLastNews = lastNews.slice(0, getActiveTabNewsDisplayed).map((news, index) => (
            <div className="broker-markets-last-news__box-news" key={index.toString()}>
                <OKBoxNewPreview
                    title={news.title}
                    date={moment(news.newsDate).format(DATE_FORMAT_TYPES[originCountry.toLowerCase()].DATE_FORMAT_DATETIME)}
                    linkContent={
                        <Link to={`/myprofile/broker/markets/last-news-detail/${news.urn}`}>
                            <FormattedText value="brokerMarketNews-readMoreNews" />
                        </Link>
                    }
                />
            </div>
            )
        )

        const buttonLoadMore = buildedLastNews.length < lastNews.length ? this.buildButtonLoadMore() : null;

        return (
            <React.Fragment>
                {buildedLastNews}
                {buttonLoadMore}
            </React.Fragment>
        );
    }

    buildTbas = () => {
        const { immBrokerMarket } = this.props;
        const tabsData = immBrokerMarket.get('allTabsNews');

        const tabs = tabsData.map(tab => {
            return (
                {
                    label: formatText(`brokerMarketNews-${tab}`),
                    content: this.buildLastNewsContent()
                }
            )
        })

        return tabs;
    }

    buildButtonLoadMore = () => {
        return (
            <div className="broker-markets-last-news__container__button-view-more">
                <OKButton
                    modifier="secondary"
                    size="small"
                    onClick={this.handleQuantityNews}
                >
                    <FormattedText value="brokerMarketNews-seeMoreNewsButton" />
                </OKButton>
            </div>
        )
    }

    handleQuantityNews = () => {
        const { activeTab } = this.state;
        const { immBrokerMarket } = this.props;
        const newsPerPage = immBrokerMarket.get("newsPerPage");

        this.setState(prevState => {
            prevState.activeTabNewsDisplayed[activeTab] = prevState.activeTabNewsDisplayed[activeTab] + newsPerPage;
            return ({ ...prevState})
        })
    }


    handleOnTabSelection = tabSelected => {
        const { immBrokerMarket, requestTabLastNews } = this.props;

        const tabsData = immBrokerMarket.get("allTabsNews");
        const tabSelectedValue = tabsData[tabSelected];
        const restOfNews = immBrokerMarket.get(tabSelectedValue, false);

        if (tabSelected !== 0 && !restOfNews) {
            requestTabLastNews(tabSelectedValue);
        }

        this.setState({activeTab: tabSelected})
    }

    buildContentBox = () => {
        const { immBrokerMarket } = this.props;
        const { activeTab } = this.state;
        const error = immBrokerMarket.get('errorLastNews') || immBrokerMarket.get('lastNews').length === 0;
        const loading = immBrokerMarket.get('fetchingLastNews');

        return (<OKLoadingErrorMessage
            isLoading={loading}
            isError={error}
        >
            <React.Fragment>
                <TabbedBox
                    onlyTabs
                    onlyContent
                    id="brokerLastNews"
                    tabs={this.buildTbas()}
                    customClassName="broker-product-file-view__content"
                    onTabSelection={this.handleOnTabSelection}
                    activeTab={activeTab}
                />
            </React.Fragment>
        </OKLoadingErrorMessage>)
    }

    render() {
        return (
            <div className="broker-markets-last-news">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="small" section="broker" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={BREADCRUMB}
                                finalTitle={<FormattedText value="brokerMarketNews-lastNewsTitle" />}
                            >
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>

                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="broker-markets-last-news__container">
                                <div className="col-xs-7">
                                    <div>
                                        <OKBoxSectionContent
                                            content={
                                                this.buildContentBox()
                                            }
                                            hasFooter
                                            footerContentLeft={
                                                <Link className="broker-markets-last-news__container__link-footer" to="/myprofile/broker/markets/">
                                                    <FormattedText value="brokerMarketNews-returnMarketsNews" />
                                                </Link>
                                            }
                                        />
                                    </div>
                                </div>
                                <div className="col-xs-5">
                                    <div className="broker-markets-last-news__commerdial-ads broker-markets-last-news__commerdial-ads">
                                        <CommercialAds path="broker/markets" type="banner-a" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

BrokerMarketsLastNewsView.propTypes = {
    immBrokerMarket: PropTypes.object,
    requestLastNews: PropTypes.func,
    requestTabLastNews: PropTypes.func,
    originCountry: PropTypes.object
};

module.exports.constructor = BrokerMarketsLastNewsView;
module.exports.BrokerMarketsLastNewsView = connect(
    state => ({
        immBrokerMarket: state.brokerMarkets,
        originCountry: state.profile.get('originCountry')
    }), {
        requestLastNews: brokerMarketsActions.requestLastNews,
        requestTabLastNews: brokerMarketsActions.requestTabLastNews
})(BrokerMarketsLastNewsView);
